module.exports = __webpack_public_path__ + "static/assets/87e8b020a5518bc77ca4ff629a09ca37.png";